import React, { useEffect, useState } from "react";
import { fetchPublicFilesWithUrls } from "../../../../lib/firebase/firebase";
import Card from "../Card";
import noDataImage from "../../../../assets/no_data_image.svg";
import { isEmbroideryTrace } from "../../../../config/appVariant";
import "./EmptyState.css";

export const EmptyState = () => {
  const [communityFiles, setCommunityFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchCommunityPreview = async () => {
      try {
        setLoading(true);
        // Fetch first 6 public community images as preview
        const result = await fetchPublicFilesWithUrls(0, 6);
        setCommunityFiles(result.files || []);
      } catch (error) {
        console.error("Error fetching community preview:", error);
        setCommunityFiles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCommunityPreview();
  }, []);

  if (loading) {
    return (
      <div className="empty-state-container">
        <div className="empty-state-content">
          <img src={noDataImage} alt="Loading" className="empty-state-image" />
          <p className="empty-state-text">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
     
        <p className="empty-state-description">
          {isEmbroideryTrace
            ? "Start creating embroidery designs or check out what the community is making!"
            : "Start creating SVGs or check out what the community is making!"}
        </p>
      </div>
      
      {communityFiles.length > 0 && (
        <div className="community-preview">
          <h4 className="community-preview-title">✨ Community Highlights</h4>
          <div className="community-preview-grid">
            {communityFiles.filter(file => file && file.uri).map((file, index) => (
              <div key={file.id || index} className="community-preview-item">
                <Card
                  file={file}
                  index={index}
                />
              </div>
            ))}
          </div>
          <p className="community-preview-footer">
            Switch to the "All" tab to explore more community creations
          </p>
        </div>
      )}
    </div>
  );
};
